export const PHONE_DISPLAY = "070-715 38 62";
export const PHONE_HREF = "tel:+46707153862";
export const FACEBOOK_URL =
  "https://www.facebook.com/p/Dellsj%C3%B6-St%C3%A4d-Tr%C3%A4dg%C3%A5rdsservice-61571139609257/";

export const NAV = [
  { id: "tjanster", label: "Tjänster" },
  { id: "omraden", label: "Områden" },
  { id: "om", label: "Om Mats" },
  { id: "arbeten", label: "Våra arbeten" },
  { id: "omdomen", label: "Omdömen" },
];

export const SERVICES = [
  {
    key: "kontor",
    title: "Kontorsstädning",
    img: "https://images.unsplash.com/photo-1774953037913-af0cf688491a?auto=format&fit=crop&w=1600&q=80",
    text: "Städning av kontor och arbetsplatser, från arbetsytor till pentry och toaletter. Upplägg efter era behov.",
    fit: "Kontor, mindre lokaler, arbetsplatser",
  },
  {
    key: "trapp",
    title: "Trappstädning & BRF",
    img: "/assets/ai-trapphus.jpg",
    text: "Städning av trapphus, entréer och gemensamma utrymmen för BRF:er och fastigheter.",
    fit: "BRF:er, fastighetsägare, förvaltare",
  },
  {
    key: "bygg",
    title: "Byggstädning",
    img: "/assets/ai-bygg.jpg",
    text: "Städning efter renovering och ombyggnad, inför inflyttning eller överlämning.",
    fit: "Byggprojekt, renoveringar, lokalanpassningar",
  },
  {
    key: "flytt",
    title: "Flyttstädning",
    img: "/assets/ai-flytt.jpg",
    text: "Flyttstädning av bostäder och lokaler. Omfattningen går vi igenom tillsammans innan arbetet börjar.",
    fit: "Lokaler, lägenheter, hyresgästbyten",
  },
  {
    key: "fonster",
    title: "Fönsterputsning",
    img: "/assets/ai-fonster.jpg",
    text: "Fönsterputs för kontor, butiker, trapphus och bostäder, efter era behov.",
    fit: "Kontor, butiker, trapphus, bostäder",
  },
];

export const TOWNS = ["Södertälje", "Trosa", "Mariefred", "Nykvarn", "Järna"];

export const SERVICE_OPTIONS = [...SERVICES.map((s) => s.title), "Trädgård", "Annat"];
export const TOWN_OPTIONS = [...TOWNS, "Annan ort i Sörmland", "Annan"];

export const REVIEWS = [
  {
    name: "Johannes K",
    rating: 5,
    date: "2026-09-08",
    text: "Lyhörd, öppen, enkel att snacka med och mån om att det ska bli bra",
  },
  {
    name: "Janica N",
    rating: 4,
    date: "2026-08-30",
    text: "Gott samarbete och lätta att kommunicera med.",
  },
  {
    name: "Eva-Lotta A",
    rating: 5,
    date: "2026-08-27",
    text: "Lätt att få kontakt med bra bemötande och lätt att boka en tid för städning",
  },
];
